export default __webpack_public_path__ + "static/media/Geography01_06.e32ffe09.png";